import { useEffect, useMemo, useState } from 'react';
import InspirationArticlesBlock from '@features/cms/components/inspirations/InspirationArticlesBlock/InspirationArticlesBlock';
import { ICmsDocument, IListingInspirationsBlock, IVoxboxInfoBlock, TCmsBlocks } from '@features/cms/typescript';
import InspirationPremiumIdeaBlock from '@features/cms/components/inspirations/InspirationPremiumIdeaBlock/InspirationPremiumIdeaBlock';
import InspirationVoxboxBlock from '@features/cms/components/inspirations/InspirationVoxboxBlock/InspirationVoxboxBlock';
import InspirationPagination from '@components/InspirationPagination/InspirationPagination';
import InspirationUpperPagination from '@components/InspirationUpperPagination/InspirationUpperPagination';
import theme from '@styles/theme';
import { IHitsInsights } from '@components/Search/typescript';
import { TAlgoliaIdeaHit, TAlgoliaProjectHit } from '@features/categories/typescript';
import { INSPIRATIONS_PER_PAGE } from '@features/cms/const';
const RenderArticlesBlocks = (blocks: Record<string, TCmsBlocks>, articles: ICmsDocument[], articlesPremium?: ICmsDocument[], filteredByTagsArticles: ICmsDocument[] = [], isInterior = false, showPagination = true, background: string = theme.rawColors.beige300, handlePageCount: () => void = () => null, pageCount = 1, hitsInsights: IHitsInsights<TAlgoliaIdeaHit | TAlgoliaProjectHit> = {
  hits: [],
  sendEvent: () => null
}, initialPageParam = 1) => {
  const [initialPage, setInitialPage] = useState(initialPageParam);
  const isFirstPage = initialPage === 1;
  const isOnInitialPage = initialPage === pageCount;
  const [articlesOffset, setArticlesOffset] = useState(Object.values(blocks).filter(block => block.type === 'listingIdeaBlock' || block.type === 'listingProjectBlock').length * 8);
  const [articlesCountPagination, setArticlesCountPagination] = useState(8);
  const articlesPerPage = INSPIRATIONS_PER_PAGE;
  const articlesCountPage = filteredByTagsArticles.length ? articlesPerPage * pageCount : articlesPerPage * (pageCount - 1) + 8;
  const maxArticlesCount = filteredByTagsArticles.length ? filteredByTagsArticles.length : Object.values(articles).length;
  useEffect(() => {
    if (filteredByTagsArticles?.length) {
      setArticlesOffset(0);
      setArticlesCountPagination(articlesCountPage >= maxArticlesCount ? maxArticlesCount : articlesCountPage);
    } else {
      setArticlesOffset(Object.values(blocks).filter(block => block.type === 'listingIdeaBlock' || block.type === 'listingProjectBlock').length * 8);
      setArticlesCountPagination(articlesCountPage >= maxArticlesCount ? maxArticlesCount : articlesCountPage);
    }
  }, [filteredByTagsArticles?.length, pageCount]);

  // TODO: optimization paginations of request after update pim system
  const handlePaginationButton = (articlesToShow: ICmsDocument[]) => {
    if (articlesOffset + articlesCountPagination + articlesPerPage < articlesToShow?.length) {
      setArticlesCountPagination(articlesCountPagination + articlesPerPage);
    } else {
      setArticlesCountPagination(articlesToShow.length - articlesOffset || 0);
    }
    handlePageCount();
  };
  const handleUpperPaginationButton = () => {
    setInitialPage(initialPage - 1);
  };
  const getActualCount = (articlesToShow: ICmsDocument[]) => {
    if (articlesToShow.length <= articlesPerPage) {
      return articlesToShow.length;
    }
    return articlesCountPagination + articlesOffset >= maxArticlesCount ? maxArticlesCount : articlesCountPagination + articlesOffset;
  };
  const renderBlocks = useMemo(() => {
    let articlesNumber = 0;
    let premiumNumber = 0;
    return Object.values(blocks).map(block => {
      switch (block.type) {
        case 'listingIdeaBlock':
        case 'listingProjectBlock':
          articlesNumber += 1;
          return <InspirationArticlesBlock key={`${block.type}-${Math.random()}`} offset={articlesNumber * 8 - 8} articles={articles} block={block as IListingInspirationsBlock} isInterior={isInterior} hitsInsights={hitsInsights} />;
        case 'listingPromotedIdeaBlock':
          premiumNumber += 1;
          return articlesPremium && articlesPremium[premiumNumber - 1] && <InspirationPremiumIdeaBlock key={`${block.type}-${Math.random()}`} article={articlesPremium[premiumNumber - 1]} block={block as IListingInspirationsBlock} isInterior={isInterior} />;
        case 'voxboxInfoBlock':
          return <InspirationVoxboxBlock key={`${block.type}-${Math.random()}`} block={block as IVoxboxInfoBlock} />;
        default:
          return null;
      }
    });
  }, []);
  const renderPagination = () => {
    const firstPageActualCount = getActualCount(filteredByTagsArticles.length ? filteredByTagsArticles : articles);
    const otherPagesActualCount = isOnInitialPage ? articlesPerPage : articlesCountPagination - 8;
    return <InspirationPagination maxCount={filteredByTagsArticles.length ? filteredByTagsArticles.length : articles?.length} actualCount={isFirstPage ? firstPageActualCount : otherPagesActualCount} handlePaginationButton={() => handlePaginationButton(filteredByTagsArticles.length ? filteredByTagsArticles : articles)} isInterior={isInterior} />;
  };
  const renderFirstPage = () => <>
      {!filteredByTagsArticles.length && renderBlocks}
      <InspirationArticlesBlock offset={articlesOffset} numberOfIdeas={articlesCountPagination} articles={filteredByTagsArticles.length ? filteredByTagsArticles : articles} isInterior={isInterior} defaultBackground={background} hitsInsights={hitsInsights} />
    </>;
  const renderOtherPages = () => <InspirationArticlesBlock offset={(initialPage - 1) * articlesPerPage} numberOfIdeas={isOnInitialPage ? articlesPerPage : (pageCount - initialPage + 1) * articlesPerPage} articles={filteredByTagsArticles.length ? filteredByTagsArticles : articles} isInterior={isInterior} defaultBackground={background} hitsInsights={hitsInsights} />;
  return <>
      <InspirationUpperPagination initialPage={initialPage} handleUpperPaginationButton={() => handleUpperPaginationButton()} />
      {isFirstPage ? renderFirstPage() : renderOtherPages()}
      {showPagination && renderPagination()}
    </>;
};
export default RenderArticlesBlocks;